import * as React from 'react';
var PerfContext = /*#__PURE__*/React.createContext({
  renderWithProps: false
});
export default PerfContext;